import React, { FunctionComponent } from "react";
import { DeactivateAccountAction } from "$components/DeactivateAccountAction";
import { TableActions } from "$components/TableActions";
import { IComponentProps } from "./interfaces";

export const Actions: FunctionComponent<IComponentProps> = ({
  className,
  visibleActions,
  deleteUserLink,
  translations
}) => (
  <TableActions className={className}>
    <>
      {visibleActions.includes("deleteUser") && (
        <DeactivateAccountAction
          link={deleteUserLink}
          tooltipMessage={translations.deleteUserTooltipMessage}
        />
      )}
    </>
  </TableActions>
);
